export default class WhiteBalance {
	constructor() {
		this.whiteBalance = {
			minValue: -4000,
			maxValue: 4000,
			calcValue: 8000,
		};

		this.tint = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};

		this.curveNames = ["WhiteBalance-R", "WhiteBalance-G", "WhiteBalance-B", "Tint-R", "Tint-G", "Tint-B"];
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate("white-balance", blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find(".white_balance_slider")
			.on("input", _ => this.whiteBalanceHandler($(element)));
		$(element)
			.find(".white_balance_range")
			.on("change", _ => this.whiteBalanceValueHandler($(element)));

		$(element)
			.find(".tint_slider")
			.on("input", _ => this.tintHandler($(element)));
		$(element)
			.find(".tint_range")
			.on("change", _ => this.tintValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
			outputInteger: true,
		});

		blocks.add({
			name: "whiteBalance",
			curves: [],
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				whiteBalance: 0,
				tint: 0,
			},
		});

		blocks.createCurves(this.curveNames, blockNum);
	}

	addPasses() {
		let shaderPass_wb = gpu.createCurveShaderPass("white balance");
		let shaderPass_tint = gpu.createCurveShaderPass("tint");

		gpu.addPassToComposer(shaderPass_wb, "toMiddle");
		gpu.addPassToComposer(shaderPass_tint, "toMiddle");
		return [shaderPass_wb, shaderPass_tint];
	}

	whiteBalanceHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let whiteValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, whiteValue);

		let block = lutify.getActiveBlock();
		block.values.whiteBalance = whiteValue;
		this.curveWBalance(block.values.whiteBalance);
	}

	tintHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[1].enabled = true;

		let tintValue = UI.getAdjustmentBlock_sliderValue($el, 1);
		UI.setAdjustmentBlock_rangeValue($el, tintValue, 1);

		let block = lutify.getActiveBlock();
		block.values.tint = tintValue / this.tint.calcValue;
		this.curveTint(block.values.tint);
	}

	whiteBalanceValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let whiteValue = UI.getAdjustmentBlock_rangeValue($el);

		if (whiteValue > this.whiteBalance.maxValue || whiteValue < this.whiteBalance.minValue) {
			if (whiteValue < this.whiteBalance.minValue) {
				whiteValue = this.whiteBalance.minValue;
				UI.setAdjustmentBlock_rangeValue($el, whiteValue);
			} else {
				whiteValue = this.whiteBalance.maxValue;
				UI.setAdjustmentBlock_rangeValue($el, whiteValue);
			}
		}

		UI.setAdjustmentBlock_sliderValue($el, whiteValue);
		lutify.getActiveBlock().values.whiteBalance = whiteValue;
		this.curveWBalance(lutify.getActiveBlock().values.whiteBalance);
	}

	tintValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[1].enabled = true;

		var tintValue = UI.getAdjustmentBlock_rangeValue($el, 1);

		if (tintValue > this.tint.maxValue) {
			tintValue = this.tint.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, tintValue, 1);
		}
		if (tintValue < this.tint.minValue) {
			tintValue = this.tint.minValue;
			UI.setAdjustmentBlock_rangeValue($el, tintValue, 1);
		}

		UI.setAdjustmentBlock_sliderValue($el, tintValue, 1);
		lutify.getActiveBlock().values.tint = tintValue / this.tint.calcValue;
		this.curveTint(lutify.getActiveBlock().values.tint);
	}

	curveWBalance(wbValue) {
		let curveR = lutify.getActiveBlock().curves[0].colorCurve;
		let curveG = lutify.getActiveBlock().curves[1].colorCurve;
		let curveB = lutify.getActiveBlock().curves[2].colorCurve;

		curveR.points = [];
		curveG.points = [];
		curveB.points = [];

		if (wbValue >= 0) {
			curveR.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00001569 });
			curveR.points.push({ x: 1.0 - wbValue * 0.00001472, y: 1.0 });

			curveG.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00000784 });
			curveG.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00000784 });

			curveB.points.push({ x: 0.0, y: 0.0 + wbValue * 0.0000155 });
			curveB.points.push({ x: 0.188, y: 0.188 - wbValue * 0.00001175 });
			curveB.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00002275 });
		} else if (wbValue < 0) {
			curveR.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
			curveR.points.push({ x: 1.0, y: 1.0 - Math.abs(wbValue) * 0.00001472 });

			curveG.points.push({ x: 0.0 + wbValue * 0.00000784, y: 0.0 });
			curveG.points.push({ x: 1.0 - wbValue * 0.00000784, y: 1.0 });

			curveB.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
			curveB.points.push({ x: 0.188, y: 0.188 + Math.abs(wbValue) * 0.00002163 });
			curveB.points.push({ x: 0.25, y: 0.25 + Math.abs(wbValue) * 0.00002672 });
			curveB.points.push({ x: 0.376, y: 0.376 + Math.abs(wbValue) * 0.00003247 });
			curveB.points.push({ x: 0.5, y: 0.5 + Math.abs(wbValue) * 0.00003382 });
			curveB.points.push({ x: 1.0 - Math.abs(wbValue) * 0.00002275, y: 1.0 });
		}

		curveR.draw();
		curveG.draw();
		curveB.draw();
		curveR.updateValues();
		curveG.updateValues();
		curveB.updateValues();

		this.callGPUWbalance(curveR.rgb, curveG.rgb, curveB.rgb);
	}

	curveTint(tintValue) {
		let curveR = lutify.getActiveBlock().curves[3].colorCurve;
		let curveG = lutify.getActiveBlock().curves[4].colorCurve;
		let curveB = lutify.getActiveBlock().curves[5].colorCurve;

		curveR.points = [];
		curveG.points = [];
		curveB.points = [];

		if (tintValue < 0) {
			curveR.points.push({ x: 0.0, y: 0.0 });
			curveR.points.push({ x: 1.0, y: 1 + tintValue * 0.1372 });

			curveG.points.push({ x: 0.0, y: 0.0 });
			curveG.points.push({ x: 0.9523, y: 0.9523 - tintValue * 0.047 });
			curveG.points.push({ x: 1.0, y: 1.0 });

			curveB.points.push({ x: 0.0, y: 0.0 });
			curveB.points.push({ x: 1.0, y: 1 + tintValue * 0.10588 });
		} else if (tintValue >= 0) {
			curveR.points.push({ x: 0.0, y: 0.0 });
			curveR.points.push({ x: 1.0 - tintValue * 0.12156, y: 1.0 });

			curveG.points.push({ x: 0.0, y: 0.0 });
			curveG.points.push({ x: 1.0, y: 1.0 - tintValue * 0.05882 });

			curveB.points.push({ x: 0.0, y: 0.0 });
			curveB.points.push({ x: 1.0 - tintValue * 0.09019, y: 1.0 });
		}

		curveR.draw();
		curveG.draw();
		curveB.draw();
		curveR.updateValues();
		curveG.updateValues();
		curveB.updateValues();

		this.callGPUTint(curveR.rgb, curveG.rgb, curveB.rgb);
	}

	callGPUWbalance(pointsRed, pointsGreen, pointsBlue) {
		let curveTexture = gpu.RGBPointsToCurve(pointsRed, pointsGreen, pointsBlue);
		lutify.getActiveBlock().passes[0].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUTint(pointsRed, pointsGreen, pointsBlue) {
		let curveTexture = gpu.RGBPointsToCurve(pointsRed, pointsGreen, pointsBlue);
		lutify.getActiveBlock().passes[1].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		let whiteBalance = values.whiteBalance;
		let tint = values.tint * this.tint.calcValue;
		UI.setAdjustmentBlock_rangeValue($block, whiteBalance);
		UI.setAdjustmentBlock_rangeValue($block, tint, 1);
		$block.find(".white_balance_range").trigger("change");
		$block.find(".tint_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
